import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import sizeColor from './sizeColor'; // keep your existing size/color component
import '../styles/productdetail.css';
import { useCart } from '../context/CartContext';

function ProductDetail() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const { addToCart } = useCart();

  useEffect(() => {
    fetch(`https://shophub-server.vercel.app/api/products/${id}`)
      .then(res => res.json())
      .then(data => {
        setProduct(data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p className="text-center mt-10">Loading product details...</p>;
  if (!product) return <p className="text-center mt-10">Product not found</p>;

  return (
    <div className="product-detail-container flex flex-col md:flex-row gap-10 px-4 md:px-12 py-10">
      <div className="bg-clothe rounded-2xl flex justify-center">
        <img
          src={product.image}
          alt={product.name}
          className="w-full max-w-[500px] h-auto object-contain"
        />
      </div>

      <div className="flex-1">
        <h1 className="text-[20px] font-semibold text-detailtext">{product.brand}</h1>
        <p className="text-name text-[30px] font-semibold">{product.name}</p>
        <p className="text-currentnav text-[42px] font-bold mb-10">${product.price}</p>

        {sizeColor()}

        <div className="mt-10 flex gap-10">
          <p className="text-[20px] font-semibold text-white rounded-lg bg-currentnav px-4 py-2">
            Description
          </p>
          <p className="text-[20px] font-semibold text-review">Review</p>
        </div>

        <p className="mt-4 text-[15px] text-gray-800">{product.details || product.description}</p>

        <div className="text-allrights text-[18px] font-semibold mt-6 space-y-2">
          <p>
            Material ....................................................................
            <span className="text-des text-[20px] font-bold ml-2">Cotton</span>
          </p>
          <p>
            Availability ..............................................................
            <span className="text-des text-[20px] font-bold ml-2">Black</span>
          </p>
          <p>
            Season .......................................................................
            <span className="text-des text-[20px] font-bold ml-2">Every Season</span>
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-4 mt-6">
          <button
            className="text-[18px] font-semibold text-white bg-currentnav px-6 py-3 rounded-xl w-full md:w-[40%] flex justify-center items-center gap-2"
            onClick={() => addToCart(product)}
          >
            <i className="bx bx-plus-circle"></i> ADD TO CART
          </button>

          <button className="border border-currentnav text-[18px] font-semibold px-6 py-3 rounded-xl w-full md:w-[40%] flex justify-center items-center">
            BUY NOW
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
